export default __webpack_public_path__ + "static/media/logo-ods_dark.61f6b103.svg";